import { createFileRoute } from "@tanstack/react-router";
import { blogRouteOptions } from "@/components/blog/blogRouteOptions";

export const Route = createFileRoute("/local-seo-in-a-map-pack-that-keeps-shrinking")(blogRouteOptions("local-seo-in-a-map-pack-that-keeps-shrinking"));
